// Copyright (c) 2023 Ryan Piaskowy. All Rights Reserved.

import React from 'react';
import './App.css';
import ImageCalendar from './components/ImageCalendar';

function App() {
  return (
    <div className="App">
      <h1 className="brand-logo" aria-label="MixIt.City">
        Mix<span className="brand-logo__accent">It</span>.City
      </h1>
      <ImageCalendar />
    </div>
  );
}

export default App;
